import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { FormComponent } from './components/form/form.component';
import { FormErrorComponent } from './components/form/form.error.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TechBlocksModule } from './techblocks.module'
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button';
import { TreeSelectModule } from 'primeng/treeselect';
// import { IconFieldModule } from 'primeng/iconfield';
// import { InputIconModule } from 'primeng/inputicon';

import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { InputMaskModule } from 'primeng/inputmask';

@NgModule({
  imports: [
    BrowserModule, 
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TechBlocksModule,
    InputTextModule,
    InputNumberModule,
    FormsModule,
    TreeSelectModule,
    ButtonModule,
    CheckboxModule,
    DialogModule,
    InputMaskModule
  ],
  declarations: [
    AppComponent,
    FormComponent,
    FormErrorComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
